<center-modal [modal]="modal">
  <ion-card>
    <ion-card-content>
      <ion-card-title class="centerText">
        Edit tags
      </ion-card-title>
      <ion-card-subtitle class="centerText">
        Press enter after typing a phrase to add the tag
      </ion-card-subtitle>
        <ion-chip *ngFor="let tag of tags; let i = index" (click)="removeTag(i)">
          <ion-label>{{tag}}</ion-label>
          <ion-icon name="close-circle-outline"></ion-icon>
        </ion-chip>
        <ion-input [(ngModel)]="tagInput" (keyup.enter)="addTag()" placeholder="Add a tag"></ion-input>
        <ion-toolbar>
          <ion-button slot="end" class="acceptButton" (click)="submitTags()">OK</ion-button>
        </ion-toolbar>
    </ion-card-content>
  </ion-card>
</center-modal>